/*******************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2016, 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 *******************************************************************************/
'use strict';

module.exports = {
  scope: null,
  clear: clear,
  error: addNotification.bind(this, 'error'),
  warn: addNotification.bind(this, 'warning'),
  info: addNotification.bind(this, 'info')
};
function clear(scope) {
  if (!scope) return;
  scope.setState(scope.initialState());
}
function addNotification(defaultKind, scope, notification) {
  if (!scope) return;
  var kind = notification.kind ? notification.kind : defaultKind;
  var notifications = scope.state && scope.state.notifications;
  if (!isNotificationDisplayedAlready(scope, notification)) {
    notifications.push({
      kind: kind,
      title: notification.message,
      subtitle: notification.details,
      format: notification.format,
      lowContrast: notification.lowContrast,
      hideClose: notification.hideClose
    });
    scope.setState({
      notifications: notifications
    });
  }
}
function isNotificationDisplayedAlready(scope, notification) {
  var notifications = scope.state && scope.state.notifications;
  var notificationAlreadyDisplayed = false;
  for (var i = 0; i < notifications.length; i++) {
    var currentNotification = notifications[i];
    if (notification.message === currentNotification.title && notification.details === currentNotification.subtitle) {
      notificationAlreadyDisplayed = true;
    }
  }
  return notificationAlreadyDisplayed;
}